module.exports = __webpack_public_path__ + "static/media/close_x.f6a5d66b.svg";